export function extractData(summaryDataObject) {
  const dataObject = summaryDataObject.summary_content;

  const extractedDataObject = {};

  Object.entries(dataObject).forEach(
    ([key, value]) => {
      extractedDataObject[key] = {
        percentage: value.percentage,
        decimal: value.decimal,
      };
    },
  );

  return extractedDataObject;
}

export function extractMaxValues(summaryObject) {
  const maxPercentageArray = [];
  const maxDecimalArray = [];

  summaryObject.forEach((dataset, index) => {
    maxDecimalArray[index] = [];
    dataset.data.forEach((object) => {
      if (object.summary_category_name !== 'Country breakdown' && object.summary_category_name !== 'Flag breakdown') {
        Object.entries(object.summary_content).forEach(
          (keyValuePairAsArray) => {
            const value = keyValuePairAsArray[1];
            if (value.percentage !== 'N/A') { maxPercentageArray.push(value.percentage); }
            maxDecimalArray[index].push(value.decimal);
          },
        );
      }
    });
  });

  let maxDecimalComp;
  let maxDecimalOverall;

  const maxPercentage = Math.max(...maxPercentageArray);
  const maxDecimalBase = Math.max(...maxDecimalArray[0]);

  if (maxDecimalArray[1]) {
    maxDecimalComp = Math.max(...maxDecimalArray[1]);
    maxDecimalOverall = (maxDecimalBase >= maxDecimalComp) ? maxDecimalBase : maxDecimalComp;
  } else {
    maxDecimalComp = Math.max(...maxDecimalArray[0]);
    maxDecimalOverall = maxDecimalBase;
  }

  return {
    maxPercentage, maxDecimalBase, maxDecimalComp, maxDecimalOverall,
  };
}

export function extractMaxValuesIndustryOverview(industryOverviewObject) {
  const maxPercentageArray = [];
  const maxDecimalArray = [];

  industryOverviewObject.forEach((dataset) => {
    Object.entries(dataset.data).forEach(
      (keyValuePairAsArray) => {
        const name = keyValuePairAsArray[0];
        const value = keyValuePairAsArray[1];
        if (name !== 'industry_average') {
          if (value.percentage !== 'N/A') { maxPercentageArray.push(value.percentage); }
          if (value.decimal !== 'N/A') { maxDecimalArray.push(value.decimal); }
        }
      },
    );
  });

  const maxPercentage = Math.max(...maxPercentageArray);
  const maxDecimal = Math.max(...maxDecimalArray);

  return { maxPercentage, maxDecimal };
}
